import { render } from "./Promote.vue?vue&type=template&id=49b8ba1f&scoped=true"
import script from "./Promote.vue?vue&type=script&lang=js"
export * from "./Promote.vue?vue&type=script&lang=js"

import "./Promote.vue?vue&type=style&index=0&id=49b8ba1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b8ba1f"]])

export default __exports__